/**
 * SendToSlackOverlay Component
 *
 * Fullscreen overlay portal for sending reports to Slack.
 * Handles portal creation and animation with a simple fade + scale effect.
 */

import React from 'react';
import { FormOverlay } from '@/components/common/FormOverlay';
import { SendToSlackForm } from './SendToSlackForm';
import type { UIBlock, ContainerBlock, InsightCardBlock } from '@/types/ui-blocks';

export interface SendToSlackOverlayProps {
  /** Whether the overlay is visible */
  isOpen: boolean;
  /** Insight preview blocks from behaviour action */
  blocks: (UIBlock | ContainerBlock | InsightCardBlock)[];
  /** Default title from the behaviour action (user can override) */
  title?: string;
  /** Callback fired when the overlay is closed */
  onClose: () => void;
  /** Callback fired when the form is successfully submitted */
  onSuccess: () => void;
}

export const SendToSlackOverlay: React.FC<SendToSlackOverlayProps> = ({
  isOpen,
  blocks,
  title,
  onClose,
  onSuccess,
}) => {
  return (
    <FormOverlay isOpen={isOpen} onClose={onClose}>
      <SendToSlackForm
        blocks={blocks}
        title={title}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </FormOverlay>
  );
};
